import request from "./api";
/**
 *    testApi   学习中心测验api
 * */
// 获取教师端测验列表
export const getTeacherTest = (params, opts) =>
    request('/api-study/teacher/course/paper', params, {
        ...opts,
        method: 'post'
    });
// 获取学生端测验列表
export const getStudentTest = (params, opts) =>
    request('/api-study/student/course/paper', params, {
        ...opts,
        method: 'post'
    });
// 获取全部章节目录
export const getChapter = (courseId, params, opts) =>
    request('/api-course/catalog/catalog/'+courseId, params, {
        ...opts
    });
// 获取教师端测验预览
export const getTeacherPreview = (params, opts) =>
    request('/api-resource/testPaper/selectPaperById', params, {
        ...opts,
        method: 'post'
    });
// 根据资源ID 获取动态参数列表
export const getParams = (questionId, params, opts) =>
    request('/api-resource/dynmaicParam/get/dynmaic/param/'+questionId, params, {
        ...opts
    });
// 获取学生端答题详情
export const getStudentPreview = (examId, courseId, classId, paperId, userId,finishFlag, params, opts) =>
    request('/api-study/queryLastExamDetail/'+examId+'/'+courseId+'/'+classId+'/'+paperId+'/'+userId+'/'+finishFlag, params, {
        ...opts
    });
// 获取学生端答题详情 - new
export const getStudentPreviewNew = (examId, paperId, userId,finishFlag, params, opts) =>
    request('/api-teachingaffair/globalExamAnswerRecord/queryExamDetail/'+examId+'/'+paperId+'/'+userId+'/'+finishFlag, params, {
        ...opts
    });
// 查看测验人数、平均分、最高分
export const getClassInfo = (paperId, classId, courseId,params, opts) =>
    request('/api-study/get/class/statistics/data/'+paperId+'/'+classId+'/'+courseId, params, {
        ...opts
    });
// 获取测验查看学生提交列表
export const getPreviewStudent = (params, opts) =>
    request('/api-study/get/class/student/list', params, {
        ...opts,
        method: 'post'
    });
// 获取答题详情统计
export const getPreviewStatistics = (paperId, classId, params, opts) =>
    request('/api-study/get/exam/answer/paper/question/accuracy/'+paperId+'/'+classId, params, {
        ...opts
    });
// 考试或者测验试卷的预览
export const testPaper = (id, params, opts) =>
    // request('/api-resource/testPaper/selectById?id='+id, params, {
    request('/api-resource/testPaper/selectByIdNoPermission?id='+id, params, {
        ...opts
    });
// 查询测验剩余作答次数
export const getExamTestCount = (id,courseId,classId,params, opts) =>
    request('/api-study/getExamTestCount/'+id+'/'+courseId+'/'+classId, params, {
        ...opts
    });
// 查看测验人数、平均分、最高分 V2
export const getClassStatisticsDataV2 = (params, opts={}) =>
  request('/api-study/getClassStatisticsDataV2', params, {
    ...opts,
    method: 'post'
  });
// 获取答题详情统计 V2
export const getExamAnswerPaperQuestionAccuracyV2 = (params, opts={}) =>
  request('/api-study/getExamAnswerPaperQuestionAccuracyV2', params, {
    ...opts,
    method: 'post'
  });

//  /api-study/gradeExport/{classId}/{courseId}/{examId}/{paperId}/{schoolId}
// 导出学生完成详情的数据
export const gradeExportList = ({ classId, courseId, examId, paperId, schoolId }) =>
  request(`/api-study/gradeExport/${classId}/${courseId}/${examId}/${paperId}/${schoolId}`);


// 撤回考试，可以继续做答
export const cancelSubmitPaper = (params) =>
  request('/api-study/cancelSubmitPaper', params, {
    method: 'post'
  });

// 强制交卷   批量
export const teacherSumbitExam = (params) =>
  request('/api-study/teacher/submit/exam', params, {
    method: 'post'
  });






// WEBPACK FOOTER //
// ./src/api/testApi.js